import { idNameItem, OpenWinLoadOption } from 'jk-service';
import { Injectable } from '@angular/core';
import { StkmaallServicePkg } from './stkmaallPkg.service';

@Injectable({
  providedIn: 'root',
})
export class StkmaallService extends StkmaallServicePkg {
  seaFutureList: idNameItem[] = [];
  _exchangeId: string = 'SGX';
  get exchangeId(): string {
    return this._exchangeId;
  }
  set exchangeId(value: string) {
    if (value !== this._exchangeId) {
      this._exchangeId = value;
      this.setExchangeStockList(this.exchangeId);
    }
  }
  constructor() {
    super();
    this.getIdNameList();
  }
  getIdNameList() {
    /*       this.idNameOpt.sqlSelect= `SELECT MA001 as id,MA002 as name,MA001+'-'+MA002 as idName,MA002+'-'+MA001 as nameId FROM STKMA`;
      this.idNameOpt.sqlWhere= ` AND MA020='N' `
      this.idNameOpt.sqlOrder= 'ORDER BY MA001';
      this.loadIdNameList(this.idNameOpt);
      */
    let r: OpenWinLoadOption = {
      mainTable: 'STKMAALL',
      item: 'S01',
      type: 'S',
      params: [],
      list: this.idNameList,
    };
    this.orm.doOpenwinLoadRx(r).subscribe({
      next: (value) => {
        this.idNameList = value.obj;
      },
      error: (error) => {
        alert(this.tableName + ' 載入錯誤:' + error.message);
      },
      complete: () => {
        if (this.idNameList) {
          this.seaFutureList = this.idNameList.filter(
            (item) => item.ps1 === 'O'
          ); //海期
          this.setExchangeStockList(this.exchangeId); // 新加坡交易所 CN0000 A50
        }
      },
    });
  }
  exchangeStockList: idNameItem[] = [];
  gotoKey(key: string): void {
    this.item = this.idNameList.find((item) => item.id === key);
  }
  setExchangeStockList(ma048: string): void {
    this.exchangeId = ma048;
    this.exchangeStockList = this.idNameList.filter(
      (item) => item.ps2 === this.exchangeId
    );
  }
}
